import { render, staticRenderFns } from "./product-advantages-item-EnterpriseMngPlatform.vue?vue&type=template&id=edd370ea&scoped=true"
import script from "./product-advantages-item-EnterpriseMngPlatform.vue?vue&type=script&lang=js"
export * from "./product-advantages-item-EnterpriseMngPlatform.vue?vue&type=script&lang=js"
import style0 from "./product-advantages-item-EnterpriseMngPlatform.vue?vue&type=style&index=0&id=edd370ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd370ea",
  null
  
)

export default component.exports